import React from "react";

function Pagination({
  current,
  total,
  onPageChange,
  totalPages,
}) {
  const onFirst = current === 1;
  const onLast = current === totalPages;

  let pages = [];

  if (totalPages <= 6) {
    for (let i = 1; i <= totalPages; i++) pages.push(i);
  } else {
    if (current <= 3) {
      pages = [1, 2, 3, 4, 'ellipsis', totalPages];
    } else if (current >= totalPages - 2) {
      pages = [1, 'ellipsis', totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    } else {
      pages = [1, 'ellipsis', current - 1, current, current + 1, 'ellipsis', totalPages];
    }
  }

  // Remove duplicate ellipsis and invalid page numbers
  pages = pages.filter((page, idx, arr) =>
    page === 'ellipsis'
      ? arr[idx - 1] !== 'ellipsis' && arr[idx + 1] !== 'ellipsis'
      : typeof page === 'number' && page <= totalPages
  );

  return (
    <nav aria-label="Pagination">
      <ul className="pagination justify-content-center">

        {/* Double Prev */}
        <li className={`page-item ${onFirst ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={() => onPageChange(Math.max(1, current - 2))}
            disabled={onFirst}
          >
            &laquo;
          </button>
        </li>

        {/* Prev */}
        <li className={`page-item ${onFirst ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={() => onPageChange(current - 1)}
            disabled={onFirst}
          >
            &lsaquo;
          </button>
        </li>

        {/* Page Numbers */}
        {pages.map((page, idx) => {
          if (page === 'ellipsis') {
            return (
              <li key={`ellipsis-${idx}`} className="page-item disabled">
                <span className="page-link">…</span>
              </li>
            );
          }

          return (
            <li key={page} className={`page-item ${page === current ? "active" : ""}`}>
              <button
                className="page-link"
                onClick={() => onPageChange(page)}
                disabled={page === current}
              >
                {page}
              </button>
            </li>
          );
        })}

        {/* Next */}
        <li className={`page-item ${onLast ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={() => onPageChange(current + 1)}
            disabled={onLast}
          >
            &rsaquo;
          </button>
        </li>

        {/* Double Next */}
        <li className={`page-item ${onLast ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={() => onPageChange(Math.min(totalPages, current + 2))}
            disabled={onLast}
          >
            &raquo;
          </button>
        </li>

      </ul>
    </nav>
  );
}

export default Pagination;
